import { lazy } from "react";

import {
  Box,
  Button,
  Column,
  Columns,
  Heading,
  Stack,
  Text
} from "@seneca/senekit";

import { useSimpleRedirectCallback } from "seneca-common/utils/hooks/routing";

import { ROUTES } from "routing/routes";

import ManualTransferButton from "./ManualTransferButton";

const NotFoundAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: "transfer-subscription-no-children-animation" */ "../animations/NotFoundAnimation"
    )
);

export default function NoChildrenPage() {
  const redirectToPremiumSettings = useSimpleRedirectCallback(
    ROUTES.PARENT.SETTINGS.PREMIUM.buildPath({})
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
      paddingX={["none", "large"]}
      minHeight={["100%", "400px"]}
    >
      <Stack align="center">
        <NotFoundAnimation />
        <Stack align="center" space="xlarge">
          <Heading align="center" level="4">
            No connected child account found
          </Heading>
          <Text align="center">
            We couldn't find a child connected to your account. Click below to
            let us know who you would like to transfer this subscription to.
          </Text>
        </Stack>
      </Stack>
      <Columns alignX="center" space="xlarge" collapseBelow="tablet">
        <Column width="content">
          <Button onClick={redirectToPremiumSettings} fill="outlined">
            Back to settings
          </Button>
        </Column>
        <Column width="content">
          <ManualTransferButton />
        </Column>
      </Columns>
    </Box>
  );
}
